import {
  GET_DOCTORS,
  GET_DOCTORS_ERROR,
  GET_DOCTORS_SUCCESS,
  GET_DOCTORS_LOADING,
  GET_DOCTORS_ROWS_PER_PAGE,
  GET_DOCTORS_PAGE_NUMBER,
  ADD_DOCTOR,
  DELETE_DOCTOR,
  UPDATE_DOCTOR,
  GET_MORE_DOCTORS,
  GET_MORE_DOCTORS_LOADING,
} from "../constants/ActionTypes";

export const getDoctors = () => {
  return {
    type: GET_DOCTORS
  };
};

export const getMoreDoctors = (lastDocument) => {
  return {
    type: GET_MORE_DOCTORS,
    payload: {
      lastDocument: lastDocument,
    },
  };
};

export const getDoctorsLoading = value => {
  return {
    type: GET_DOCTORS_LOADING,
    payload: value
  };
};

export const getMoreDoctorsLoading = value => {
  return {
    type: GET_MORE_DOCTORS_LOADING,
    payload: value,
  };
};

export const getDoctorsError = error => {
  return {
    type: GET_DOCTORS_ERROR,
    payload: error
  };
};

export const getDoctorsSuccess = (doctorsList, lastDocument) => {
  return {
    type: GET_DOCTORS_SUCCESS,
    payload: {
      doctorsList,
      lastDocument,
    }
  };
};

export const setRowsPerPage = value => {
  return {
    type: GET_DOCTORS_ROWS_PER_PAGE,
    payload: value
  };
};

export const setPageNumber = value => {
  return {
    type: GET_DOCTORS_PAGE_NUMBER,
    payload: value
  };
};

export const addDoctor = doctorObject => {
  return {
    type: ADD_DOCTOR,
    payload: doctorObject
  };
};

export const updateDoctor = doctorObject => {
  return {
    type: UPDATE_DOCTOR,
    payload: doctorObject,
  }
}

export const deleteDoctor = doctorObject => {
  return {
    type: DELETE_DOCTOR,
    payload: doctorObject
  };
};


// export const getMoreDOCTORS = () => {
//   return {
//     type: GET_MORE_DOCTORS
//   };
// };
